import React, { Component } from 'react';
import { Table, Form, Popover } from 'antd';
import { Link } from 'react-router';
import moment from 'moment';
import util from '@util/index';
import '../expenses.less';
import ModalInvalid from './ModalInvalid';

class Manage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: this.props.dataSource,
      modalInvalidVisible: false,
      data: {},
    };
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    this.setState({
      dataSource: nextProps.dataSource,
    });
  }

  // table分页跳转
  handleChange = (pagination, filters, sorter) => {
    this.props.onChange(pagination, filters, sorter);
  };

  showModalInvalid = data => {
    this.setState({
      modalInvalidVisible: true,
      data,
    });
  };

  cancelModalInvalid = () => {
    this.setState({
      modalInvalidVisible: false,
    });
  };

  submitInvalid = (value, data) => {
    const params = {
      uuids: [data.uuid],
      reason: value.reason,
    };
    this.props.invoiceInvalid(params);
    this.cancelModalInvalid();
  };

  columns = () => {
    const {
      dataSource: { pagination },
    } = this.state;
    const current = pagination.current || 1;
    const total = pagination.total || 0;
    let config = [
      {
        title: '编号',
        dataIndex: 'num',
        render: (text, record, index) => {
          return <span>{total - (current - 1) * 15 - index}</span>;
        },
      },
      {
        title: '开票单号',
        dataIndex: 'no',
        render: (text, record) => {
          return <Link to={`/finance/i_manage/open/${record.uuid}`}>{text}</Link>;
        },
      },
      {
        title: '开票公司',
        dataIndex: 'company',
        key: 'company',
      },
      {
        title: '金额',
        dataIndex: 'price',
        key: 'price',
        render: text => <span>{util.numberFormat(text, 2, '.', ',')}</span>,
      },
      {
        title: '申请理由',
        dataIndex: 'reason',
        key: 'reason',
        width: 200,
        render: text => {
          const content = (
            <div style={{ maxWidth: '600px' }}>
              <span>{text}</span>
            </div>
          );
          return (
            <Popover content={content}>
              <p className="ellip">{text}</p>
            </Popover>
          );
        },
      },
      {
        title: '申请人',
        dataIndex: 'createUserName',
        key: 'createUserName',
      },
      {
        title: '申请时间',
        dataIndex: 'createTime',
        key: 'createTime',
        render: (text, record) => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '当前环节-处理人',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => {
          const instance = record.instance || {};
          const currentActivity = instance.currentActivity || {};
          const { name, processorName } = currentActivity;
          return <span>{currentActivity.uuid ? `${name || ''}-${processorName || ''}` : ''}</span>;
        },
      },
      {
        title: '完成时间',
        dataIndex: 'finishTime',
        key: 'finishTime',
        render: (text, record) => {
          const a = moment.unix(record.finishTime / 1000);
          const b = moment.unix(record.createTime / 1000);
          return (
            <span>
              {record.finishTime ? (
                <span>
                  {moment.unix(record.finishTime / 1000).format('YYYY-MM-DD')}
                  <span>(用时{a.diff(b, 'days')}天)</span>
                </span>
              ) : (
                ''
              )}
            </span>
          );
        },
      },
      {
        title: '状态',
        dataIndex: 'status',
        render: (text, record) => {
          switch (record.status) {
            case 0:
              return <span>审核中</span>;
            case 1:
              if (record.invalid) {
                return <span>已作废</span>;
              }
              return <span style={{ color: 'red' }}>已完成</span>;

            default:
              return <span>待编辑</span>;
          }
        },
      },
      {
        title: '操作',
        dataIndex: 'done',
        render: (text, record) => {
          return (
            <div>
              {record.status === 1 && !record.invalid && this.props.type !== 'mine' ? (
                <Link onClick={() => this.showModalInvalid(record)}>发票作废</Link>
              ) : null}
              {record.invalid ? (
                <Popover content={record.invalidReason}>
                  <a>作废原因</a>
                </Popover>
              ) : null}
            </div>
          );
        },
      },
    ];
    if (this.props.type === 'mine') {
      config = config.filter(item => item.dataIndex !== 'createUserName');
    }
    return config;
  };

  render() {
    const {
      dataSource: { list, pagination },
      modalInvalidVisible,
      data,
    } = this.state;
    return (
      <div>
        <Table
          rowKey="uuid"
          dataSource={list}
          pagination={pagination}
          columns={this.columns()}
          loading={this.props.loading}
          onChange={this.handleChange}
        />
        {modalInvalidVisible ? (
          <ModalInvalid
            data={data}
            visible={modalInvalidVisible}
            onCancel={this.cancelModalInvalid}
            onOk={this.submitInvalid}
            {...this.props}
          />
        ) : null}
      </div>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Manage);



// WEBPACK FOOTER //
// ./src/components/finance/invoice/TableExpenses.js